import { useEffect, useState } from "react";
import { localDateKey } from "@/hooks/useLocalDate";

export const NO_MARIAN_CELEBRATION = "No Marian celebration appears on the General Roman Calendar today. Yet every day, the Church contemplates Christ with Mary, his Mother.";

export const useTodayCalendar = (date) => {
  const year = date.getFullYear();
  const [result, setResult] = useState({ year: null, records: [], error: "" });
  useEffect(() => {
    const controller = new AbortController();
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/calendar/events?year=${year}&calendar=roman-of`, { signal: controller.signal })
      .then(async (response) => {
        if (!response.ok) throw new Error("Today’s General Roman Calendar could not be loaded. Please consult the calendar for available editions.");
        return response.json();
      })
      .then((records) => setResult({ year, records, error: "" }))
      .catch((error) => { if (error.name !== "AbortError") setResult({ year, records: [], error: "Today’s General Roman Calendar is temporarily unavailable. Please try again or consult the calendar." }); });
    return () => controller.abort();
  }, [year]);
  const records = result.year === year ? result.records : [];
  // The older category classifier includes Joseph; he is not a Marian celebration.
  const feast = records.find((event) => event.date === localDateKey(date) &&
    ((event.category === "marian" && !/joseph/i.test(event.id)) || /annunciation|presentation_of_the_lord/.test(event.id)));
  return { feast, loading: result.year !== year, error: result.year === year ? result.error : "" };
};